import { createAction, createAsyncAction } from 'typesafe-actions';

import {
    AiChatFeedbackListResponse,
    AiChatListResponse,
    DataResponse,
    Dataset,
} from '@portal/common/types';

import { EventType, VisualizationType } from './models';
import { State } from './reducer';

export const changeInsightsFilters = createAction('INSIGHTS_FILTERS_CHANGED')<
    Partial<State[keyof State]>
>();

export const validateAndSetInsightsFilters = createAction('INSIGHTS_FILTERS_VALID_AND_SET')<
    Partial<State[keyof State]>
>();

export const initializeInsightsFilters = createAction('INSIGHTS_FILTERS_INITIALIZED')<EventType>();

export const changeDataProjectId = createAction('CHANGED_DATA_PROJECT')<{
    dataProjectId: number[];
    datasets: Dataset[];
}>();

export const changeExportIncludeIds = createAction('CHANGED_EXPORT_INCLUDE_IDS')<boolean>();

export type InsightsDataResponse = DataResponse | AiChatListResponse | AiChatFeedbackListResponse;

export const getInsightsData = createAsyncAction(
    'GET_INSIGHTS_DATA_REQUEST',
    'GET_INSIGHTS_DATA_SUCCESS',
    'GET_INSIGHTS_DATA_FAILURE'
)<void, InsightsDataResponse, string>();

export const getInsightsCompanyUsageData = createAsyncAction(
    'GET_INSIGHTS_COMPANY_USAGE_DATA_REQUEST',
    'GET_INSIGHTS_COMPANY_USAGE_DATA_SUCCESS',
    'GET_INSIGHTS_COMPANY_USAGE_DATA_FAILURE'
)<void, DataResponse, string>();

export const setVisualizationOptions = createAction('SET_VISUALIZATION_OPTIONS')<
    VisualizationType[]
>();
